import styled from "styled-components";
import {
	DESKTOP_M_BP,
	COLOR_BORDER_GREY,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_WHITE,
	FONT_WT_LIGHT,
	TABLET_BP,
	FONT_WT_REGULAR,
	COLOR_LIGHT_GREY,
	COLOR_TEXT_HIGHLIGHT,
	COLOR_HYPERLINK,
} from "@website-builder/utilities-index";

export const ModalContainer = styled.div`
	.modal {
		@media only screen and (max-width: ${TABLET_BP}px) {
			width: 100%;
			min-height: 100vh;
			top: 0;
		}
		padding: 0;
		background-color: ${COLOR_LIGHT_GREY} !important;
	}
`;

export const CareerTrackModalWrapper = styled.div`
	width: 1200px;
	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		width: unset;
	}
	@media only screen and (min-width: ${TABLET_BP + 1}px) {
		.modalDropdownView {
			display: none;
		}
	}
`;

export const ModalHeading = styled.div`
	font-size: 30px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	text-align: center;
	margin-top: 20px;
	margin-bottom: 25px;
	@media only screen and (max-width: ${TABLET_BP}px) {
		font-size: 24px;
		padding-top: 20px;
	}
`;

export const CardsWrapper = styled.div`
	display: inline-flex;
	padding: 0 5% 20px;
	width: 100%;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	@media only screen and (max-width: ${TABLET_BP}px) {
		display: none;
	}
`;

export const CourseCard = styled.div`
	display: inline-flex;
	flex-direction: column;
	margin: 10px;
	background-color: transparent;
	min-width: 320px;
	max-width: 320px;
`;

export const CardContainer = styled.div`
	padding: 10px;
	margin-bottom: 20px;
	background-color: ${COLOR_WHITE};
`;

export const CardHeader = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	min-height: auto;
`;

export const Heading = styled.div`
	font-size: 20px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	line-height: 1.4;
	margin-top: 20px;
	margin-bottom: 10px;
	@media only screen and (max-width: ${TABLET_BP}px) {
		font-weight: ${FONT_WT_LIGHT};
		margin-top: 10px;
	}
`;

export const Content = styled.p`
	font-size: 14px;
	line-height: 22px;
	text-align: center;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	font-weight: ${FONT_WT_LIGHT};
	margin-bottom: 20px;
	margin-top: 0;
	@media only screen and (max-width: ${TABLET_BP}px) {
		text-align: left;
	}
`;

export const SectionContainer = styled.div`
	@media only screen and (min-width: ${TABLET_BP + 1}px) {
		min-height: 260px;
	}
`;

export const Section = styled.section`
	margin-top: 10px;
	@media only screen and (min-width: ${TABLET_BP + 1}px) {
		:first-child {
			min-height: 125px;
		}
		:nth-child(2) {
			min-height: 115px;
		}
	}

	.sectionHeading {
		color: ${COLOR_TEXT_HIGHLIGHT};
		font-size: 13px;
		font-weight: ${FONT_WT_MEDIUM};
		line-height: 22px;
		text-align: center;
		margin-top: 0;
		margin-bottom: 10px;
		@media only screen and (max-width: ${TABLET_BP}px) {
			text-align: left;
		}
	}
	.sectionDescription {
		font-size: 14px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: 22px;
		text-align: center;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		margin-top: 0;
		margin-bottom: 10px;
		@media only screen and (max-width: ${TABLET_BP}px) {
			text-align: left;
		}
	}
`;

export const CtaWrapper = styled.div`
	text-align: center;
	@media only screen and (max-width: ${TABLET_BP}px) {
		padding-top: 10px;
	}
	.careerTrackCta {
		width: 275px;
		font-weight: ${FONT_WT_REGULAR};
		@media only screen and (max-width: ${TABLET_BP}px) {
			font-size: 16px;
			width: unset;
		}
	}
`;

export const TagSection = styled.div`
	width: 100% !important;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 10px;
	p {
		margin-top: 0;
		margin-bottom: 0;
		font-size: 18px;
		margin-right: 8px;
		font-weight: ${FONT_WT_REGULAR};
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	a {
		line-height: 31px;
		letter-spacing: 0.5px;
		color: ${COLOR_HYPERLINK};
		font-weight: ${FONT_WT_REGULAR};
		font-size: 18px;
		:hover {
			text-decoration: none;
		}
	}
`;

export const CareerTrackOptionWrapper = styled.div`
  .careerTrackPreview {
    position: relative;
    height: 90px;
    padding: 20px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    ${(props) =>
			!props.isLastOption
				? `border-bottom:  1px solid ${COLOR_BORDER_GREY};`
				: ""};
    border-bottom: ${(props) =>
			!props.isExpanded ? `1px solid ${COLOR_BORDER_GREY}` : "none"};
    position: relative;
    .expandArrow {
      margin-right: 10px;
      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-right: 5px solid ${COLOR_TEXT_PRIMARY_B2C};
        border-bottom: 5px solid ${COLOR_TEXT_PRIMARY_B2C};
        transform: ${(props) =>
					props.isExpanded ? "rotateZ(-135deg)" : "rotateZ(315deg)"}
          translate(-25%, -25%);
      }
    }
  }
  &:last-child {
    .careerTrackComponents {
      border-bottom: none;
    }
  }
  .careerTrackComponents {
    height: ${(props) => (props.isExpanded ? "auto" : "0")};
    overflow: ${(props) => (props.isExpanded ? "unset" : "hidden")};
    padding: ${(props) =>
			props.isExpanded ? "0px 20px 20px 20px" : "0px 0px 0px 20px"};
    border-bottom: ${(props) =>
			props.isExpanded ? `1px solid ${COLOR_BORDER_GREY}` : "none"};
    transition: all 0s ease-in-out;
  }
  @media only screen and (max-width: ${TABLET_BP}px) {
    .careerTrackPreview {
      .expandArrow {
        flex: unset;
        margin-right: 0px;
        span {
          width: 15px;
          height: 15px;
        }
    }
    }
`;
